import React from 'react'
import {Button, Card, CardBody, CardHeader, Col, Row} from 'reactstrap';
import {Button as SementicBtn} from 'semantic-ui-react'
// import '../ViewAllCheckIn/ViewAllCheckIn.vms-policy-css'
import {MDBDataTable} from 'mdbreact'
import * as common from '../../../const/Common/CommonFunc';
import LabelInput from "../../../components/Input/LabelInput/LabelInput";
import LabelDropdown from "../../../components/Dropdown/LabelDropdown/LabelDropdown";
import {connect} from "react-redux";
import * as actionCreator from "../../../store/Action";
import Cookies from "js-cookie";
// import axios from "../../../axios/axios_visitortag";
import axios from "../../../axios/axios_tag";
import {Empty, Tooltip} from "antd";
import Spinner from "../../../components/Spinner/Spinner";
import {DatePicker} from "antd";
import moment from "moment";
import '../../../react-antd.css'
import $ from "jquery";
import Download from '../../../components/Button/DownloadbleButton'
import apiConfig from "../../../axios/axios_api_services";

const {RangePicker} = DatePicker;

function disabledDate(current) {
  return current && current > moment().endOf("day");
}

class App extends React.Component {

  state = {
    selectedColumn: "",
    searchDetails: "",
    visitors_list: [],
    visitors_history: [],
    checkoutColumns: [

      {
        label: 'Full Name',
        field: 'fullName',
        sort: 'asc'
      },
      {
        label: 'User Name',
        field: 'userName',
        sort: 'asc'
      },
      {
        label: 'Coporate Name',
        field: 'coporateName',
        sort: 'asc'
      },
      {
        label: 'Email',
        field: 'email',
        sort: 'asc'


      },
      {
        label: 'User Roles',
        field: 'userRoles',
        sort: 'asc'
      },
      {
        label: 'LogDate',
        field: 'logDate',
        sort: 'asc'
      }

    ]
  };
  fillData = () => {
    $("#history-table > tbody > tr").each(function () {
      if ($(this).find('td').eq(1).text() === "OVERDUE") {
        $(this).css("background-color", "rgb(255, 211, 211)") //#ff9696

      }
      if ($(this).find('td').eq(1).text() === "CHECKED_OUT") {
        $(this).css("background-color", "rgb(251, 253, 215)") //rgb(249, 255, 150)
      }

      if ($(this).find('td').eq(1).text() === "CHECKED_IN") {
        $(this).css("background-color", "rgb(214, 236, 247)") //rgb(175, 229, 255)
      }
    });
  };
  onChange = (date, dateString) => {

    if (dateString[0] === "" || dateString[1] === "") {

    } else {
      let start = new Date(dateString[0]);
      let end = new Date(dateString[1]);
      this.getAllHistory(start.getTime(), end.getTime());
    }
  };

  async getAllHistory(startDate, endDate) {
    this.props.spinnerHandler(true);

    const headers = {
      "Authorization": "Bearer " + Cookies.get("68a6102f6ed24899420170004a0273b8")
    };

    let corporateId = this.props.usr_obj.userRoles === "SYS_ADMIN" ? 0 : this.props.usr_obj.corporates[0].corporateId;
    // Get all history
    await axios.get(apiConfig.CORPORATE_LOGIN_DETAILS({corporateId:corporateId,startDate:startDate,endDate:endDate}), {headers: headers}
    )
      .then(async response => {
        let _array = [];

        if (response.data.success) {
          let visitors = response.data.adminUserLogList;

          if (visitors.length !== 0) {
            visitors.map((visitor, index) => {
              let obj = {...visitor};
              _array.push(obj);
            })
          }
        }

        this.setState({
          visitors_list: _array,
          visitors_history: _array
        });
      })

      .catch(async error => {
        let result = await common.checkErrorResponse(error);
        if (result === 1) {
          this.getAllHistory(startDate, endDate);
        } else {
          this.props.spinnerHandler(false)

        }
      })

      .finally(fin => {
        this.props.spinnerHandler(false);
      });
  };

  componentDidMount() {
    let start = new Date().setDate(new Date().getDate() - 30);
    let end = new Date().setDate(new Date().getDate());

    this.getAllHistory(start, end);

    this.fillData();
    $('#history-table').bind('DOMSubtreeModified', this.fillData.bind(this));
  }

  render() {
    let rows = [];
    if (this.state.visitors_list.length !== 0) {
      this.state.visitors_list.map((value, index) => {
        rows.push(
          {

            fullName: value.fullName,
            userName: value.userName,
            coporateName: value.coporateName,
            email: value.email,
            userRoles: value.userRoles,
            logDate: value.logDate,
          }
        )
      });
    }

    let columns = this.state.checkoutColumns;
    let data = {columns, rows};
    return (

      <div>
        <Row>
          <Col xs="12" sm="12" md="12" lg="12" xl="12">
            <Card>
              <CardHeader>
                Search Details
              </CardHeader>

              <CardBody className=" paddingBottom">
                <div className="form-group paddingBottom">
                  <Row>
                    <Col xs="4" sm="4" md="4" lg="4" xl="4">
                      <RangePicker
                        size={"mini"}
                        defaultValue={[moment().subtract(30, "days"), moment().subtract(0, "days")]}
                        disabledDate={disabledDate}
                        format="YYYY-MM-DD"
                        onChange={this.onChange}
                      />
                    </Col>
                  </Row>
                </div>
              </CardBody>
            </Card>
          </Col>
        </Row>

        <Row>
          <Col lg="12">

            <Card className="card margin0">
              <CardHeader>
                LogIn History
                <Download data={this.state.visitors_list} userType={"LOGIN_HISTORY"}/>
              </CardHeader>
              <CardBody>
                <Row>
                  <Col lg="12">
                    {
                      this.state.visitors_list.length !== 0 ?
                        <MDBDataTable
                          id={"history-table"}
                          responsive
                          responsiveSm
                          responsiveMd
                          responsiveLg
                          responsiveXl
                          bordered
                          hover
                          data={data}/>
                        :
                        <div className={"align-center fully-width"}>
                          <Empty description={"Records not found"} className={"empty-icon"}/>
                        </div>
                    }
                  </Col>
                </Row>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  visitors: state.viewAllCheckIN.visitors,
  checkInVisitors: state.viewAllCheckIN.checkInVisitors,
  historyColumns: state.viewAllCheckIN.historyColumns,
  column: state.viewAllCheckIN.column,

  usr_obj: state.userReducer.user,
});

const mapDispatchToProps = (dispatch) => {
  return {
    // spinner handler
    spinnerHandler: (data) => dispatch(actionCreator.spinnerHandler(data)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(App);
